// ------------------------------------------------------------------
// Service architecture — three divisions.
// Role/trade names are neutral descriptions of the categories we
// source for; no certification is implied for any individual worker.
// ------------------------------------------------------------------

export const WHITE_COLLAR = [
  {
    id: "hse-sheq",
    icon: "ShieldCheck",
    title: "HSE / SHEQ Professionals",
    roles: ["HSE / SHEQ Professionals", "HSE Managers", "HSE Advisors", "Safety Engineers"],
  },
  {
    id: "project-leadership",
    icon: "ClipboardList",
    title: "Project & Site Leadership",
    roles: ["Project Managers", "Site Managers", "Construction Managers", "Supervisors"],
  },
  {
    id: "engineering-quality",
    icon: "Ruler",
    title: "Engineering & Quality",
    roles: ["Engineers", "QA/QC Professionals", "Technical Professionals"],
  },
  {
    id: "planning-controls",
    icon: "CalendarRange",
    title: "Planning & Project Controls",
    roles: ["Planners", "Document Controllers", "Other qualified professional personnel"],
  },
];

export const BLUE_COLLAR = [
  {
    id: "construction-site",
    icon: "HardHat",
    title: "Construction & Site Operatives",
    roles: ["Certified Spotters", "Certified Banksmen", "Ground Workers", "General Construction Operatives", "Steel Structure Erectors", "Sandwich Panel Installers"],
  },
  {
    id: "plant-equipment",
    icon: "Truck",
    title: "Plant & Equipment Operators",
    roles: ["Certified Forklift Operators", "Certified MEWP Operators", "Certified Excavator Operators", "Certified Dumper Operators", "Other Plant & Equipment Operators"],
  },
  {
    id: "mechanical-industrial",
    icon: "Wrench",
    title: "Mechanical & Industrial Trades",
    roles: ["Pipe Fitters", "Mechanical Fitters", "HVAC Technicians", "Industrial Technicians"],
  },
  {
    id: "electrical-specialist",
    icon: "Zap",
    title: "Electrical & Specialist Installation",
    roles: ["Electrical Technicians", "Fire System Installation Technicians", "Fire Alarm & Detection Technicians", "Electrical Installers"],
  },
  {
    id: "steel-fabrication",
    icon: "Flame",
    title: "Steel & Fabrication",
    roles: ["Certified Welders", "Fabricators", "Steel Structure Erectors"],
  },
  {
    id: "specialist-finishing",
    icon: "Layers",
    title: "Specialist Finishing",
    roles: ["Resin Flooring Specialists", "Industrial Flooring Operatives", "Specialist Construction Finishers"],
  },
];
